/** Push a custom event to GTM dataLayer (GA4 tags listen via Custom Event triggers). */
export function pushGtmEvent(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

const SIGN_UP_SENT_PREFIX = "fractional_gtm_sign_up_sent_";

function signupAlreadySent(userId) {
  try {
    return sessionStorage.getItem(`${SIGN_UP_SENT_PREFIX}${userId}`) === "1";
  } catch {
    return false;
  }
}

function markSignupSent(userId) {
  try {
    sessionStorage.setItem(`${SIGN_UP_SENT_PREFIX}${userId}`, "1");
  } catch {
    /* ignore */
  }
}

function resolveAuthMethod(user) {
  const provider =
    user?.app_metadata?.provider ||
    user?.identities?.[0]?.provider ||
    user?.app_metadata?.providers?.[0];
  return provider || "email";
}

/** True when SIGNED_IN likely reflects a brand-new account (e.g. OAuth redirect). */
function isLikelyNewUser(user) {
  if (!user?.created_at) return false;
  const created = new Date(user.created_at).getTime();
  const lastSignIn = user.last_sign_in_at
    ? new Date(user.last_sign_in_at).getTime()
    : created;
  return Math.abs(created - lastSignIn) < 120_000;
}

/**
 * Fire GTM sign_up once per user (email SIGNED_UP or first OAuth SIGNED_IN).
 * GTM: Custom Event trigger event name = sign_up → GA4 Event tag.
 */
export function trackSignUpForGtm(authEvent, session) {
  const user = session?.user;
  if (!user?.id || signupAlreadySent(user.id)) return;

  const shouldTrack =
    authEvent === "SIGNED_UP" ||
    (authEvent === "SIGNED_IN" && isLikelyNewUser(user));

  if (!shouldTrack) return;

  pushGtmEvent("sign_up", {
    method: resolveAuthMethod(user),
  });
  markSignupSent(user.id);
}
